import { useEffect, useState } from 'react'
import Link from 'next/link'
// Components
import PuppyCard from '../newPuppyCard'
// Utils
import { stateMap } from '@utils'
import { NearbyDogs } from '@/types'

import styles from './NearByStyles.module.scss'

interface NearByProps {
  nearbyDogs: NearbyDogs
  title: string
  isMobile: boolean
}

const NearBy = ({ nearbyDogs, title, isMobile }: NearByProps) => {
  /* PUPPY CARD */
  const [autosize, setAutosize] = useState(false)
  useEffect(() => setAutosize(isMobile), [isMobile])

  if (Object.entries(nearbyDogs).length === 0) {
    return null
  }

  return (
    <div className={styles.nearbyDogsContainer}>
      <div className={styles.sectionTitle}>
        <h2>{title}</h2>
      </div>

      {Object.values(nearbyDogs).map((dogs, i) => {
        // get state name and slug from state map
        let stateName
        let stateSlug
        for (const state in stateMap) {
          if (
            stateMap[state].state.toUpperCase() ===
            dogs[0]?.breeder?.state.toUpperCase()
          ) {
            stateSlug = state
            stateName = stateMap[state].name
          }
        }

        return (
          <div key={i} className={styles.dogStateContainer}>
            <div className={styles.title}>
              <Link href={`/puppies-for-sale/${stateSlug}`}>
                {' '}
                <h3>Our Puppies in {stateName}</h3>
              </Link>
              {dogs.length >= 4 && (
                <Link
                  href={`/search?state=${stateSlug}`}
                  className={styles.link}
                >
                  View All
                </Link>
              )}
            </div>
            <div className={styles.nearbyCardsContainer}>
              {dogs.map((d, i) => (
                <PuppyCard
                  key={i}
                  dog={d}
                  autosize={autosize}
                  state={stateName}
                />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default NearBy
